import { Form, message } from "antd";
import BaseModalForm from "components/BaseModalForm";
import { getVocabulary } from "components/Vocabulary";
import moment from "moment";
import React, { forwardRef } from "react";
import ExceptionAPI from "restAPI/ExceptionAPI";
import { FieldTypes } from "utils/formUtils";

const ExceptionApprovalandSubmitModal = forwardRef(
  function ExceptionApprovalandSubmitModal(
    {
      showMessage,
      afterClose,
      id,
      history,
      title,
      okText,
      isSubmittingForApproval = false,
    },
    ref,
  ) {
    const [form] = Form.useForm();
    const fields = [
      {
        render: () => showMessage,
      },
      {
        name: "newEndDate",
        label: "Please update end date as it has already passed",
        placeholder: "End Date",
        type: FieldTypes.DATE,
        required: true,
        props: {
          disabledDate: (currentDate) => {
            return currentDate && currentDate < moment().startOf("days");
          },
        },
      },
      {
        name: "notes",
        label: "Note",
        type: FieldTypes.TEXT_AREA,
        required: true,
      },
    ];
    const onSubmit = async (data) => {
      if (isSubmittingForApproval) {
        await ExceptionAPI.triggerSubmit(data, id, true).promise;
        message.success("Submitted successfully.");
        history.goBack();
      } else {
        await ExceptionAPI.approveException(id, data).promise;
        message.success(`Successfully approved ${getVocabulary("exception")}`);
      }
    };
    return (
      <>
        <BaseModalForm
          modalProps={{ okText: okText }}
          form={form}
          title={title}
          onOk={onSubmit}
          ref={ref}
          fields={fields}
          afterClose={afterClose}
        />
      </>
    );
  },
);

export default ExceptionApprovalandSubmitModal;
